export default __webpack_public_path__ + "static/media/foot-right-inside.e63e30f1.png";